import React from 'react';

const text = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14
};

function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
}

const CurrentItemPosition = ({ totalItemCount, pageSize, pageNumber }) => {
    let firstItem, lastItem;

    if (pageSize < 0) {
        // return all
        firstItem = 1;
        lastItem = totalItemCount;
    } else {
        firstItem = totalItemCount > 0 ? (pageNumber - 1) * pageSize + 1 : 0;
        lastItem = clamp(pageNumber * pageSize, 0, totalItemCount);
    }

    return (
        firstItem <= lastItem && (
            <div id='pagingInfo' style={text}>
                {`${firstItem}-${lastItem} of ${totalItemCount}`}
            </div>
        )
    );
};

export default CurrentItemPosition;
